import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { fmtUSD } from "@/lib/money";

export const PaymentResultBanner = ({ state, paidAmount }) => {
  if (state === "checking") {
    return (
      <div data-testid="payment-checking-banner"
        className="border border-border bg-[#0A0A0A] rounded-sm p-4 flex items-center gap-3">
        <Loader2 className="w-5 h-5 text-[#007AFF] animate-spin" />
        <p className="text-sm">Confirming your payment with Stripe…</p>
      </div>
    );
  }
  if (state === "success") {
    return (
      <div data-testid="payment-success-banner"
        className="border border-emerald-800 bg-emerald-950/40 rounded-sm p-4 flex items-center gap-3">
        <CheckCircle2 className="w-5 h-5 text-emerald-400" />
        <p className="text-sm">
          Payment complete — <span className="font-mono font-bold">{fmtUSD(paidAmount)}</span> in credits added to your balance.
        </p>
      </div>
    );
  }
  if (state === "error") {
    return (
      <div data-testid="payment-error-banner"
        className="border border-red-900 bg-red-950/40 rounded-sm p-4 flex items-center gap-3">
        <XCircle className="w-5 h-5 text-red-400" />
        <p className="text-sm">We couldn't confirm this payment. If you were charged, your credits will appear shortly — otherwise please try again.</p>
      </div>
    );
  }
  return null;
};
